// src/components/brandCustomization/TicketCustomization/TicketLayoutSelector.jsx
import React from 'react';
import { FaPalette } from 'react-icons/fa';
import { availableLayouts } from '../../../utils/brandCustomization';

/**
 * TicketLayoutSelector - Selector visual de modelos de diseño para tarjeta
 */
const TicketLayoutSelector = ({
    selectedLayout,
    onChange
}) => {
    const layouts = availableLayouts.ticket || [];

    return (
        <div className="mb-6 p-4 bg-gradient-to-r from-purple-50 to-pink-50 border border-purple-200 rounded-lg">
            <h4 className="text-lg font-semibold text-gray-900 mb-4 flex items-center">
                <FaPalette className="mr-2 text-purple-500" />
                Modelo de Diseño
            </h4>
            <p className="text-sm text-gray-600 mb-4">
                Selecciona el diseño base para la tarjeta. Cada modelo tiene un estilo visual diferente.
            </p>
            <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
                {layouts.map((layout) => (
                    <button
                        key={layout.id}
                        type="button"
                        onClick={() => onChange(layout.id)}
                        className={`p-4 rounded-lg border-2 transition-all text-left ${selectedLayout === layout.id
                                ? 'border-purple-500 bg-purple-50 shadow-md'
                                : 'border-gray-200 bg-white hover:border-purple-300 hover:bg-purple-50'
                            }`}
                    >
                        <div className="flex items-start justify-between mb-2">
                            <span className="text-3xl">{layout.preview}</span>
                            {selectedLayout === layout.id && (
                                <span className="text-purple-500 text-sm font-semibold">✓ Seleccionado</span>
                            )}
                        </div>
                        <h5 className="font-semibold text-gray-900 mb-1">{layout.name}</h5>
                        <p className="text-xs text-gray-600">{layout.description}</p>
                    </button>
                ))}
            </div>
        </div>
    );
};

export default TicketLayoutSelector;

